var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVoucherErrorCalendar = function SvgVoucherErrorCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#voucher-error-calendar_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.02 22.76H87.98v63.862a1.36 1.36 0 0 1-1.358 1.36H2.378a1.359 1.359 0 0 1-1.358-1.36V22.76Z",
    fill: "#EADFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.455 22.76h81.527v59.786H7.814a1.358 1.358 0 0 1-1.359-1.359V22.76Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.622 89H2.378A2.378 2.378 0 0 1 0 86.622V22.759a1.033 1.033 0 0 1 1.02-1.019h86.96A1.033 1.033 0 0 1 89 22.76v63.862A2.377 2.377 0 0 1 86.622 89ZM2.038 23.778v62.844a.34.34 0 0 0 .34.34h84.244a.34.34 0 0 0 .34-.34V23.778H2.038Z",
    fill: "#30384C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.378 7.813h84.245A1.359 1.359 0 0 1 87.98 9.17V22.76H1.02V9.171a1.359 1.359 0 0 1 1.358-1.358Z",
    fill: "#EADFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.814 7.813h78.809a1.359 1.359 0 0 1 1.359 1.358v8.153H7.814a1.359 1.359 0 0 1-1.359-1.359V9.171a1.359 1.359 0 0 1 1.359-1.358Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.98 23.779H1.02A1.032 1.032 0 0 1 0 22.759V9.173a2.391 2.391 0 0 1 2.378-2.378h84.244A2.378 2.378 0 0 1 89 9.172V22.76a1.032 1.032 0 0 1-1.02 1.019ZM2.039 21.74h84.924V9.17a.34.34 0 0 0-.34-.339H2.378a.34.34 0 0 0-.34.34V21.74Z",
    fill: "#30384C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5 15.626a1.02 1.02 0 0 1 0-2.038 3.057 3.057 0 0 0 3.057-3.057V5.095a3.057 3.057 0 1 0-6.114 0v2.718a1.02 1.02 0 0 1-2.039 0V5.095a5.095 5.095 0 1 1 10.191 0v5.436a5.11 5.11 0 0 1-5.095 5.095ZM60.804 15.626a1.02 1.02 0 0 1 0-2.038 3.057 3.057 0 0 0 3.058-3.057V5.095a3.057 3.057 0 1 0-6.115 0v2.718a1.02 1.02 0 0 1-2.038 0V5.095a5.095 5.095 0 1 1 10.19 0v5.436a5.095 5.095 0 0 1-5.095 5.095ZM77.111 15.626a1.02 1.02 0 0 1 0-2.038 3.058 3.058 0 0 0 3.057-3.057V5.095a3.057 3.057 0 0 0-6.114 0v2.718a1.02 1.02 0 0 1-2.038 0V5.095a5.095 5.095 0 0 1 10.19 0v5.436a5.095 5.095 0 0 1-5.095 5.095ZM28.195 15.626a1.02 1.02 0 0 1 0-2.038 3.058 3.058 0 0 0 3.057-3.057V5.095a3.057 3.057 0 0 0-6.114 0v2.718a1.02 1.02 0 0 1-2.038 0V5.095a5.096 5.096 0 0 1 10.19 0v5.436a5.109 5.109 0 0 1-5.095 5.095ZM11.888 15.626a1.02 1.02 0 0 1 0-2.038 3.057 3.057 0 0 0 3.058-3.057V5.095a3.057 3.057 0 1 0-6.115 0v2.718a1.019 1.019 0 1 1-2.038 0V5.095a5.095 5.095 0 0 1 10.19 0v5.436a5.11 5.11 0 0 1-5.095 5.095Z",
    fill: "#30384C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.469 55.37H67.15v11.55H78.47V55.37Z",
    fill: "#EADFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.15 55.37h7.243v6.115a1.359 1.359 0 0 1-1.36 1.358H67.15V55.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.469 67.94h-11.32a1.02 1.02 0 0 1-1.018-1.02V55.37a1.02 1.02 0 0 1 1.019-1.018h11.319a1.033 1.033 0 0 1 1.019 1.019v11.55a1.033 1.033 0 0 1-1.02 1.018Zm-10.3-2.039h9.28V56.39h-9.28V65.9Z",
    fill: "#30384C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.85 43.82H10.53v11.55H21.85V43.82Z",
    fill: "#EADFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.531 43.82h7.242v6.115a1.359 1.359 0 0 1-1.358 1.359H10.53V43.82Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.85 56.39H10.53a1.033 1.033 0 0 1-1.018-1.02V43.82a1.033 1.033 0 0 1 1.019-1.018h11.318a1.019 1.019 0 0 1 1.02 1.019v11.55a1.02 1.02 0 0 1-1.02 1.018Zm-10.3-2.039h9.28V44.84h-9.28v9.511Z",
    fill: "#30384C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.168 43.82H21.85v11.55h11.318V43.82Z",
    fill: "#EADFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.85 43.82h7.242v6.115a1.359 1.359 0 0 1-1.359 1.359H21.85V43.82Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.168 56.39H21.849a1.033 1.033 0 0 1-1.019-1.02V43.82a1.033 1.033 0 0 1 1.02-1.018h11.318a1.019 1.019 0 0 1 1.019 1.019v11.55a1.02 1.02 0 0 1-1.02 1.018Zm-10.3-2.039h9.28V44.84h-9.28v9.511Z",
    fill: "#30384C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5 43.82H33.182v11.55H44.5V43.82Z",
    fill: "#EADFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.182 43.82h7.242v6.115a1.359 1.359 0 0 1-1.359 1.359h-5.883V43.82Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5 56.39H33.18a1.019 1.019 0 0 1-1.019-1.02V43.82a1.02 1.02 0 0 1 1.02-1.018H44.5a1.033 1.033 0 0 1 1.019 1.019v11.55a1.033 1.033 0 0 1-1.02 1.018ZM34.2 54.35h9.28V44.84H34.2v9.511Z",
    fill: "#30384C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.819 43.82H44.5v11.55h11.319V43.82Z",
    fill: "#EADFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5 43.82h7.242v6.115a1.359 1.359 0 0 1-1.358 1.359H44.5V43.82Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.818 56.39H44.5a1.033 1.033 0 0 1-1.02-1.02V43.82a1.033 1.033 0 0 1 1.02-1.018h11.318a1.02 1.02 0 0 1 1.02 1.019v11.55a1.02 1.02 0 0 1-1.02 1.018Zm-10.3-2.039H54.8V44.84h-9.28v9.511Z",
    fill: "#30384C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.15 43.82H55.833v11.55h11.319V43.82Z",
    fill: "#EADFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.832 43.82h7.242v6.115a1.358 1.358 0 0 1-1.358 1.359h-5.884V43.82Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.15 56.39H55.818a1.033 1.033 0 0 1-1.02-1.02V43.82a1.033 1.033 0 0 1 1.02-1.018H67.15a1.033 1.033 0 0 1 1.02 1.019v11.55a1.033 1.033 0 0 1-1.02 1.018ZM56.837 54.35h9.294V44.84h-9.294v9.511Z",
    fill: "#30384C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.469 43.82H67.15v11.55H78.47V43.82Z",
    fill: "#EADFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.15 43.82h7.243v6.115a1.359 1.359 0 0 1-1.36 1.359H67.15V43.82Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.469 56.39h-11.32a1.02 1.02 0 0 1-1.018-1.02V43.82a1.02 1.02 0 0 1 1.019-1.018h11.319a1.033 1.033 0 0 1 1.019 1.019v11.55a1.033 1.033 0 0 1-1.02 1.018Zm-10.3-2.039h9.28V44.84h-9.28v9.511Z",
    fill: "#30384C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.819 32.27H44.5v11.55h11.319V32.27Z",
    fill: "#EADFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5 32.27h7.242v6.115a1.359 1.359 0 0 1-1.358 1.359H44.5V32.27Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.818 44.84H44.5a1.033 1.033 0 0 1-1.02-1.02V32.272a1.033 1.033 0 0 1 1.02-1.019h11.318a1.02 1.02 0 0 1 1.02 1.019v11.55a1.02 1.02 0 0 1-1.02 1.019Zm-10.3-2.038H54.8V33.29h-9.28v9.512Z",
    fill: "#30384C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.15 32.27H55.833v11.55h11.319V32.27Z",
    fill: "#EADFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.832 32.27h7.242v6.115a1.358 1.358 0 0 1-1.358 1.359h-5.884V32.27Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.15 44.84H55.818a1.033 1.033 0 0 1-1.02-1.02V32.272a1.033 1.033 0 0 1 1.02-1.019H67.15a1.033 1.033 0 0 1 1.02 1.019v11.55a1.033 1.033 0 0 1-1.02 1.019Zm-10.313-2.038h9.294V33.29h-9.294v9.512Z",
    fill: "#30384C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.469 32.27H67.15v11.55H78.47V32.27Z",
    fill: "#EADFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.15 32.27h7.243v6.115a1.359 1.359 0 0 1-1.36 1.359H67.15V32.27Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.469 44.84h-11.32a1.02 1.02 0 0 1-1.018-1.02V32.272a1.02 1.02 0 0 1 1.019-1.019h11.319a1.033 1.033 0 0 1 1.019 1.019v11.55a1.033 1.033 0 0 1-1.02 1.019Zm-10.3-2.038h9.28V33.29h-9.28v9.512Z",
    fill: "#30384C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.85 55.37H10.53v11.55H21.85V55.37Z",
    fill: "#EADFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.531 55.37h7.242v6.115a1.359 1.359 0 0 1-1.358 1.358H10.53V55.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.85 67.94H10.53a1.033 1.033 0 0 1-1.018-1.02V55.37a1.033 1.033 0 0 1 1.019-1.018h11.318a1.019 1.019 0 0 1 1.02 1.019v11.55a1.02 1.02 0 0 1-1.02 1.018ZM11.55 65.9h9.28V56.39h-9.28V65.9Z",
    fill: "#30384C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.168 55.37H21.85v11.55h11.318V55.37Z",
    fill: "#EADFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.85 55.37h7.242v6.115a1.359 1.359 0 0 1-1.359 1.358H21.85V55.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.168 67.94H21.849a1.033 1.033 0 0 1-1.019-1.02V55.37a1.033 1.033 0 0 1 1.02-1.018h11.318a1.019 1.019 0 0 1 1.019 1.019v11.55a1.02 1.02 0 0 1-1.02 1.018Zm-10.3-2.039h9.28V56.39h-9.28V65.9Z",
    fill: "#30384C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5 55.37H33.182v11.55H44.5V55.37Z",
    fill: "#EADFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.182 55.37h7.242v6.115a1.359 1.359 0 0 1-1.359 1.358h-5.883V55.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5 67.94H33.18a1.02 1.02 0 0 1-1.019-1.02V55.37a1.02 1.02 0 0 1 1.02-1.018H44.5a1.033 1.033 0 0 1 1.019 1.019v11.55a1.033 1.033 0 0 1-1.02 1.018ZM34.2 65.9h9.28V56.39H34.2V65.9Z",
    fill: "#30384C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.819 55.37H44.5v11.55h11.319V55.37Z",
    fill: "#EADFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5 55.37h7.242v6.115a1.359 1.359 0 0 1-1.358 1.358H44.5V55.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.818 67.94H44.5a1.034 1.034 0 0 1-1.02-1.02V55.37a1.033 1.033 0 0 1 1.02-1.018h11.318a1.02 1.02 0 0 1 1.02 1.019v11.55a1.02 1.02 0 0 1-1.02 1.018Zm-10.3-2.039H54.8V56.39h-9.28V65.9Z",
    fill: "#30384C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.85 66.92H10.53v11.55H21.85V66.92Z",
    fill: "#EADFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.531 66.92h7.242v6.114a1.359 1.359 0 0 1-1.358 1.36H10.53V66.92Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.85 79.488H10.53a1.032 1.032 0 0 1-1.018-1.019V66.92A1.033 1.033 0 0 1 10.53 65.9h11.318a1.02 1.02 0 0 1 1.02 1.02v11.55a1.02 1.02 0 0 1-1.02 1.018Zm-10.3-2.038h9.28v-9.511h-9.28v9.511Z",
    fill: "#30384C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.168 66.92H21.85v11.55h11.318V66.92Z",
    fill: "#EADFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.85 66.92h7.242v6.114a1.359 1.359 0 0 1-1.359 1.36H21.85V66.92Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.168 79.488H21.849a1.032 1.032 0 0 1-1.019-1.019V66.92a1.032 1.032 0 0 1 1.02-1.019h11.318a1.02 1.02 0 0 1 1.019 1.02v11.55a1.02 1.02 0 0 1-1.02 1.018Zm-10.3-2.038h9.28v-9.511h-9.28v9.511Z",
    fill: "#30384C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5 66.92H33.182v11.55H44.5V66.92Z",
    fill: "#EADFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.182 66.92h7.242v6.114a1.359 1.359 0 0 1-1.359 1.36h-5.883V66.92Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5 79.488H33.18a1.02 1.02 0 0 1-1.019-1.019V66.92a1.02 1.02 0 0 1 1.02-1.019H44.5a1.032 1.032 0 0 1 1.019 1.02v11.55a1.032 1.032 0 0 1-1.02 1.018ZM34.2 77.45h9.28v-9.511H34.2v9.511Z",
    fill: "#30384C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.819 66.92H44.5v11.55h11.319V66.92Z",
    fill: "#EADFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5 66.92h7.242v6.114a1.359 1.359 0 0 1-1.358 1.36H44.5V66.92Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.818 79.488H44.5a1.033 1.033 0 0 1-1.02-1.019V66.92A1.033 1.033 0 0 1 44.5 65.9h11.318a1.02 1.02 0 0 1 1.02 1.02v11.55a1.019 1.019 0 0 1-1.02 1.018Zm-10.3-2.038H54.8v-9.511h-9.28v9.511Z",
    fill: "#30384C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.15 55.37H55.833v11.55h11.319V55.37Z",
    fill: "#EADFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.832 55.37h7.242v6.115a1.358 1.358 0 0 1-1.358 1.358h-5.884V55.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.15 67.94H55.818a1.033 1.033 0 0 1-1.02-1.02V55.37a1.033 1.033 0 0 1 1.02-1.018H67.15a1.033 1.033 0 0 1 1.02 1.019v11.55a1.033 1.033 0 0 1-1.02 1.018ZM56.837 65.9h9.294V56.39h-9.294V65.9Z",
    fill: "#30384C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.469 67.94h-11.32a1.02 1.02 0 0 1-1.018-1.02V55.37a1.02 1.02 0 0 1 1.019-1.018h11.319a1.033 1.033 0 0 1 1.019 1.019v11.55a1.033 1.033 0 0 1-1.02 1.018Zm-10.3-2.039h9.28V56.39h-9.28V65.9ZM30.912 38.046H18.968a1.02 1.02 0 0 1 0-2.038h11.944a1.02 1.02 0 0 1 0 2.038ZM13.534 38.046H10.53a1.02 1.02 0 0 1 0-2.038h3.003a1.02 1.02 0 0 1 0 2.038ZM37.706 31.252H18.982a1.019 1.019 0 1 1 0-2.038h18.724a1.02 1.02 0 1 1 0 2.038ZM13.534 31.252H10.53a1.019 1.019 0 1 1 0-2.038h3.003a1.019 1.019 0 1 1 0 2.038Z",
    fill: "#30384C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "voucher-error-calendar_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h89v89H0z"
  })))));
};
export default SvgVoucherErrorCalendar;